"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FooterModule {
}
exports.FooterModule = FooterModule;
